<template>
    <div class="mt20 ovh min_height" >
        <div v-show="showDetail == 0">
            <div align="right" style="margin-bottom: 5px;">
                   <!-- <el-button v-if="auditContractAuth == 1" @click="confirmAuditContract" type="primary">确认合同</el-button>-->
                    <el-button v-if="hasEditContract == 1" @click="openAddContract(0)" type="primary">新增合同</el-button>

            </div>
            <el-table :data="agreementList" style="width: 100%"  border >
                <el-table-column prop="contractCode" label="合同编号" width="200" align="center">
                </el-table-column>
                <el-table-column prop="contractName" label="合同名称" min-width="150" align="center">
                </el-table-column>
                <el-table-column prop="categoryName" label="主营品类" align="center" min-width="300" >
                    <template scope="scope">
                        <p v-for="category in scope.row.categoryLevels">{{category.grandName}}-{{category.parentName}}-{{category.childrenName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="开始时间" align="center" min-width="120">
                    <template scope="scope">
                        <span >{{scope.row.contractStartDate | time}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结束时间" align="center" min-width="120">
                    <template scope="scope">
                        <span >{{scope.row.contractEndDate | time}}</span>
                    </template>
                </el-table-column>
                <!--<el-table-column prop="statusDesc" label="审核状态" align="center" min-width="80">
                </el-table-column>-->
                <el-table-column label="操作" align="center" fixed="right" min-width="200">

                    <template scope="scope">
                        <el-button @click="detail(scope.row.id,1)" type="text" size="small">查看详情</el-button>
                        <el-button v-if="hasEditContract ==1 " @click="openAddContract(scope.row.id)" type="text" size="small">编辑合同</el-button>
                        <el-button v-if="hasEditContract ==1 && scope.row.applyStatus == 4" @click="removeAgreement(scope.row.id)" type="text" size="small">删除</el-button>
                        <el-button v-if="scope.row.hasConfirmContract ==1 " @click="detail(scope.row.id,2)" type="text" size="small">确认证件齐全</el-button>
                        <el-button v-if="scope.row.hasConfirmDeposit ==1 " @click="detail(scope.row.id,2)" type="text" size="small">确认收到保证金</el-button>
                        <!--<router-link :to="{path:'brandDetail',query: {brandApplyId:scope.row.brandApplyId}}"  target="_blank">
                            <el-button @click="" type="text" size="small">查看详情</el-button>
                        </router-link>-->
                        <!--<router-link :to="{path:'brandDetail',query: {brandApplyId:scope.row.brandApplyId}}" class="el-button el-button&#45;&#45;text el-button&#45;&#45;small" target="_blank">查看详情</router-link>-->
                    </template>
                </el-table-column>
            </el-table>

            <div align="center" v-if="secondAuditAuth == 1">
                <!--<el-button  type="primary" @click="confirmRejectQualification">驳回资质信息</el-button>
                <el-button  type="primary" @click="confirmRejectContract">驳回合同</el-button>
                <el-button  type="primary" @click="confirmAuditSecond">通过复审</el-button>-->
               <!-- <el-button type="primary" class="mr10" @click="confirmContract">
                    法务确认证件齐全(合同信息数据库暂时自己添加)
                </el-button>
                <el-button type="primary" class="mr10" @click="confirmDeposit">
                    财务确认收到保证金(合同信息数据库暂时自己添加)
                </el-button>
                <h1>链接格式如下所示：</h1>
                <h1>http://127.0.0.1:8010/#/supplier_apply_audit?supplierApplyId=65&agreementId=9</h1>-->
            </div>

            <!--<div align="center" v-if="allConfirmationAuth == 1">
                <el-button type="primary" class="mr10" @click="confirmContract">
                    法务确认证件齐全(合同信息数据库暂时自己添加)
                </el-button>
                <el-button type="primary" class="mr10" @click="confirmDeposit">
                    财务确认收到保证金(合同信息数据库暂时自己添加)
                </el-button>
                <h1>链接格式如下所示：</h1>
                <h1>http://127.0.0.1:8010/#/supplier_apply_audit?supplierApplyId=65&agreementId=9</h1>
            </div>-->
        </div>

        <div class="pl10 mt20"  v-show="showDetail == 1">
            <span class="dib">合同基本信息</span><span class="line"></span>
            <div class="mt20">
                <el-form label-width="207px" class="demo-ruleForm">
                    <el-form-item label="供应商合同编号："><span>{{ agreementDetail.contractCode }}</span></el-form-item>
                    <el-form-item label="供应商编号："><span>{{ agreementDetail.suppliersCode }}</span></el-form-item>
                    <el-form-item label="供应商名称："><span>{{ agreementDetail.suppliersName }}</span></el-form-item>
                    <el-form-item label="合作方式：">
                        <span v-if="agreementDetail.cooperationType == 1" >入仓</span>
                        <span v-if="agreementDetail.cooperationType == 2">入仓（实销实结）</span>
                        <span v-if="agreementDetail.cooperationType == 3">自发货</span>
                    </el-form-item>
                    <el-form-item label="发货时效：" v-if="agreementDetail.cooperationType == 3"><span>{{ agreementDetail.deliveryTime }}小时</span></el-form-item>
                    <el-form-item label="合同开始时间："><span>{{ agreementDetail.contractStartTime }}</span></el-form-item>
                    <el-form-item label="合同结束时间："><span>{{ agreementDetail.contractEndTime }}</span></el-form-item>
                    <span class="dib">主营品牌信息</span><span class="line"></span>
                    <el-table :data="agreementDetail.applyAgreementBrandList"  border style="width: 80%;margin: 0 auto;margin-bottom:22px;margin-top: 22px">
                        <el-table-column prop="brandName" label="品牌" width="200" align="center">
                        </el-table-column>
                        <el-table-column  label="合作品类" width="180" align="center">
                        <template scope="scope">
                            <span>{{scope.row.categoryLevel.grandName}}-{{scope.row.categoryLevel.parentName}}-{{scope.row.categoryLevel.childrenName}}</span>
                        </template>
                        </el-table-column>
                        <el-table-column label="是否提供发票" align="center">
                            <template scope="scope">
                                <span  v-if="scope.row.provideInvoice == 0">否</span>
                                <span  v-if="scope.row.provideInvoice == 1">是</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="发票类型" align="center">
                            <template scope="scope">
                                <span  v-if="scope.row.provideInvoice == 0">-</span>
                                <span  v-if="scope.row.provideInvoice == 1 && scope.row.invoiceType == 1">增值税普通发票</span>
                                <span  v-if="scope.row.provideInvoice == 1 && scope.row.invoiceType == 2">增值税专用发票</span>
                                <span  v-if="scope.row.provideInvoice == 1 && scope.row.invoiceType == 3">形式发票</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="税率" align="center">
                            <template scope="scope" v-if="scope.row.rate !=null && scope.row.rate != undefined ">
                                <span v-if="scope.row.rate ==null || scope.row.rate == undefined"></span>
                            <span  v-for="rateValue in scope.row.rate.split(',')" v-if="rateValue">
                                {{rateValue}}%&nbsp;
                            </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <span class="dib">合同条款-财务信息</span><span class="second_line"></span>
                    <el-form-item label="结算主体：">
                        <span v-if="agreementDetail.settlementBodyId == 1" >北京果敢时代科技有限公司</span>
                        <span v-if="agreementDetail.settlementBodyId == 2" >MAMA HONG KONG</span>
                        <span v-if="agreementDetail.settlementBodyId == 3" >天津果敢时代国际贸易有限公司</span>
                        <span v-if="agreementDetail.settlementBodyId == 4" >正合奇胜（天津）企业咨询管理有限公司</span>
                        <span v-if="agreementDetail.settlementBodyId == 5" >老师线下打款</span>
                    </el-form-item>
                    <el-form-item label="结算方式：">
                        <span v-if="agreementDetail.settlementType == 1" >直采</span>
                        <span v-if="agreementDetail.settlementType == 2" >预付款</span>
                        <span v-if="agreementDetail.settlementType == 3" >实销实结</span>
                    </el-form-item>
                    <el-form-item label="结算币种：">人民币</el-form-item>
                    <el-form-item v-if="agreementDetail.settlementType != 2 && agreementDetail.settlementPaymentType==0" label="结算账期："><span>{{ agreementDetail.settlementPaymentDays }}天</span></el-form-item>
                    <el-form-item v-if="agreementDetail.settlementType != 2 && agreementDetail.settlementPaymentType &&agreementDetail.settlementPaymentType>=2" label="结算账期：">
                        <span v-if="agreementDetail.settlementPaymentType==2">按年结算</span>
                        <span v-if="agreementDetail.settlementPaymentType==3">按半年结算</span>
                        <span v-if="agreementDetail.settlementPaymentType==4">按季度结算</span>
                        <span v-if="agreementDetail.settlementPaymentType==5">按月结算</span>
                        <span v-if="agreementDetail.settlementPaymentType==6">按半月结算</span>
                    </el-form-item>
                    <el-form-item v-if="agreementDetail.settlementType == 2" label="结算账期：">
                        <span v-for="(paymentRate,index) in agreementDetail.settlementPaymentRate.split(',')">{{index==0?"":","}}第{{index+1}}期{{ paymentRate }}%</span>
                    </el-form-item>
                    <el-form-item label="是否需要保证金：">
                        <span v-if="agreementDetail.shouldDeposit == 0" >不需要</span>
                        <span v-if="agreementDetail.shouldDeposit == 1" >需要</span>
                    </el-form-item>
                    <el-form-item label="保证金：">
                        <span>{{ agreementDetail.deposit }}人民币</span>
                        <el-button v-if="agreementDetail.hasConfirmDeposit == 1  && showView==2" type="primary" class="mr10" @click="confirmDeposit(agreementDetail.id)">
                            财务确认收到保证金
                        </el-button>
                    </el-form-item>
                    <el-form-item label="货款支付方式：">甲方将货款直接支付到乙方的如下银行账户</el-form-item>
                    <el-form-item label="开户银行："><span>{{ agreementDetail.bankName }}</span></el-form-item>
                    <el-form-item label="银行账号："><span>{{ agreementDetail.accountNumber }}</span></el-form-item>
                    <el-form-item label="银行户名："><span>{{ agreementDetail.accountName }}</span></el-form-item>
                    <el-form-item v-if="agreementDetail.registeredCountry != 1" label="SwiftCode："><span>{{ agreementDetail.swiftCode }}</span></el-form-item>
                    <el-form-item v-if="agreementDetail.registeredCountry == 1" label="省："><span>{{ agreementDetail.province }}</span></el-form-item>
                    <el-form-item v-if="agreementDetail.registeredCountry == 1" label="市："><span>{{ agreementDetail.city }}</span></el-form-item>
                    <span class="dib">线上合同信息</span><span class="line"></span>
                    <el-form-item label="合同名称：">
                        <div style="margin-left: 0px;margin-top: 20px" v-if="supplierEditContract ==1">
                            <div class="agree_wrap" v-for="val in agreementDetail.templateContents">
                                <div class="in_block">
                                    <span class="agree">{{ val.name }}</span>
                                    <el-button type="primary" @click="editAgree(val,agreementDetail.contractCode)">编辑</el-button>
                                </div>
                            </div>
                        </div>
                        <template v-if="supplierEditContract ==0">
                            <span v-for="(content,index) in agreementDetail.templateContents">
                                <el-button @click="contentDetail(content)" type="text" size="small">&nbsp;{{content.name}}&nbsp;</el-button>
                            </span>
                        </template>
                    </el-form-item>

                    <!-- 入境货物检验检疫证明 -->
                    <el-form-item v-if="agreementDetail.hasConfirmContract == 1 && showView==2 && agreementDetail.signContract !=1 "
                                  label="纸质合同电子版：" class="dib mt20">
                        <span class="f666 f12">请将纸质合同扫描件上传到系统</span>
                        <el-upload action="/suppliers/uploadImages?biz=0" name="pic"
                                   :file-list="contractFileArr"
                                   list-type="picture-card"
                                   :on-preview="handlePictureCardPreview"
                                   :on-remove="handleRemove"
                                   :before-upload="beforeUpload"
                                   :on-success="handleSuccess">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                    </el-form-item>
                    <el-form-item  v-if="agreementDetail.hasConfirmContract == 1  && showView==2 && agreementDetail.signContract !=1 ">
                        <el-button   type="primary" class="mr10" @click="confirmContract(agreementDetail.id)">
                            法务确认证件齐全
                        </el-button>确认之后，系统会开通供应商入驻相关权限
                    </el-form-item>
                    <el-form-item  v-if="agreementDetail.signContract ==1 " label="纸质合同电子版：" class="dib mt20">
                        <div>
                            <img @click="previewPic($event)" class="pic_skan" v-for="contractFile in agreementDetail.contractFileArr" :src="contractFile">
                        </div>
                    </el-form-item>

                    <!-- 保存 -->
                    <div class="w60 auto mtb20">
                        <el-button type="primary" @click="reback()">返回合同协议列表</el-button>
                    </div>
                </el-form>
                <el-dialog :visible.sync="dialogVisible" size="small">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
                <el-dialog :visible.sync="dialogVisible2" size="small">
                    <img width="100%" :src="dialogImageUrl2" alt="">
                </el-dialog>
            </div>
        </div>
    </div>

</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                // 图片预览
                dialogImageUrl: '',
                dialogVisible: false,
                dialogImageUrl2: '',
                dialogVisible2: false,
                showDetail: 0,
                agreementDetail: {
                  applyAgreementBrandList:[]
                },
                supplierEditContract:0,
                agreementList: [],
                hasEditContract : 0,
                secondAuditAuth : 0,
                supplierApplyId : 0,
                auditContractAuth : 0,
                editContractAuth : 0,
                agreementId : 0,
                allConfirmationAuth : 0,
                contractFileArr:[],
                showView:1,//显示查看还是审核
            };
        },
        methods: {
            contentDetail(val){
                window.open("/suppliers/index2/#/" + val.fileName + "_view?type=0&contentId=" + val.contentId + "&templateId=" + val.templateId);
            },
            editAgree(val,contractCode){
                window.open("/suppliers/index2/#/" + val.fileName
                    + "_edit?type=0&contentId=" + val.contentId
                    + "&templateId=" + val.templateId
                    + "&agreementCode=" + contractCode
                    + "&editType=2"
                );
            },
            initAgreementList(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/agreement/list',
                    data: {
                        applyId: supplierApplyId,
                        pageNo: 1,
                        pageSize: 100
                    },
                    success: function(result) {
                        if (!result.code && result.code==0) {
                            that.agreementList = result.data.data;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        }  else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 确认保证金
            confirmDeposit (agreementId) {
                if(!agreementId || agreementId<0) {
                    this.$message.error('未知合同协议ID');
                    return;
                }
                var that = this;


                this.$prompt('请输入备注信息', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                    inputErrorMessage: '请输入备注信息'
                }).then(({ value }) => {
                    if(!value || value == ""){
                        that.$message.error('备注信息必须填写');
                        return false;
                    }

                    $.get({
                        url: '/suppliers/supplierSettled/confirm/deposit',
                        data: {
                            agreementId: agreementId,
                            content:value
                        },
                        success: function(result) {
                            if (!result.code) {
                                that.$message({
                                    message: '确认收到保证金成功',
                                    type: 'success'
                                });
                                that.initAgreementList(that.supplierApplyId);
                                that.$parent.$refs.basicTemplate.initProgress(that.supplierApplyId);
                                that.$parent.$refs.brandListTemplate.initBrandList(that.supplierApplyId);
                                that.reback();
                            } else {
                                that.$message.error('确认收到保证金失败，请联系管理员');
                            }
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消确认保证金'
                    });
                });
            },

            // 确认合同
            confirmContract (agreementId) {
                if(!agreementId || agreementId<0) {
                    this.$message.error('未知合同协议ID');
                    return;
                }
                var Data = {};
                var that = this;
                if(!that.contractFileArr || that.contractFileArr.length<=0) {
                    that.$message.error('请务必上传上传全部合同扫描件图片到系统');
                    return;
                }
                var fileArr = this.fileTransToArray(that.contractFileArr);
                $.get({
                    url: '/suppliers/supplierSettled/confirm/contract',
                    data: {
                        agreementId: agreementId,
                        contractFileArr : fileArr
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.$message({
                                message: '确认收到合同文件成功',
                                type: 'success'
                            });
                            that.initAgreementList(that.supplierApplyId);
                            that.$parent.$refs.basicTemplate.initProgress(that.supplierApplyId);
                            that.$parent.$refs.brandListTemplate.initBrandList(that.supplierApplyId);
                            that.reback();

                            //this.$router.push('/supplier_applies');
                        } else {
                            that.$message.error('确认收到合同文件失败，请联系管理员');
                        }
                    }
                })
            },

            /**
             * 确认驳回资质
             */
            confirmRejectQualification() {
                var that = this;
                this.$prompt('请输入驳回原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                    inputErrorMessage: '请输入驳回原因'
                }).then(({ value }) => {
                    that.rejectQualification(value);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消驳回资质'
                    });
                });
            },

            /**
             * 驳回资质
             * @param content
             */
            rejectQualification (content) {
                var Data = {};
                var that = this;
                that.agreementDetail.suppliersApplyId = this.supplierApplyId;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.agreementDetail.suppliersApplyId,
                        reject:1,
                        content:content
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.$message({
                                message: '驳回成功',
                                type: 'success'
                            });
                            window.opener = null;
                            window.open('', '_self');
                            window.close();
                        } else {
                            that.$message.error('驳回失败，请联系管理员');
                        }
                    }
                })
            },

            /**
             * 确认驳回合同
             */
            confirmRejectContract() {
                var that = this;
                this.$prompt('请输入驳回原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                    inputErrorMessage: '请输入驳回原因'
                }).then(({ value }) => {
                    that.rejectContract(value);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消驳回合同'
                    });
                });
            },

            /**
             * 驳回合同
             * @param content
             */
            rejectContract (content) {
                var Data = {};
                var that = this;
                that.agreementDetail.suppliersApplyId = this.supplierApplyId;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.agreementDetail.suppliersApplyId,
                        reject:2,
                        content:content
                    },
                    success: function(result) {
                        if (!result.code) {
                            this.$message({
                                message: '驳回成功',
                                type: 'success'
                            });
                            window.opener = null;
                            window.open('', '_self');
                            window.close();
                        } else {
                            this.$message.error('驳回失败，请联系管理员');
                        }
                    }
                })
            },

            confirmAuditSecond() {
                var that = this;
                this.$confirm('确认审核通过', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.auditSecond();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消复审'
                    });
                });
            },
            // 预览 图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 删除 上传图片
            handleRemove(file, fileList) {
                this.contractFileArr = fileList;
                console.log(fileList);
                console.log(file, fileList);
            },
            handleSuccess(response, file) {
                if (!response.code) {
                    this.contractFileArr.push({url:response.data});
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 转化图片 格式[{url}]
            fileTrans(fileUrl){
                var array = [];
                if(fileUrl) {
                    var files = fileUrl.split(',');
                    for(var i=0;i<files.length;i++) {
                        var file = {};
                        file.url = files[i];
                        console.log(file);
                        array.push(file);
                    }
                }
                return array;
            },
            fileTransToArray(files){
                var fileArray = [];
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            fileArray.push(files[i].url);
                        }
                    }
                }
                return fileArray;
            },
            // 图片转化成字符串
            fileTransToString(files){
                var fileStr = "";
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            if(i!=0) {
                                fileStr += ",";
                            }
                            fileStr += files[i].url;
                        }
                    }
                }
                return fileStr;
            },
            auditSecond () {
                var Data = {};
                var that = this;
                that.agreementDetail.suppliersApplyId = this.supplierApplyId;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.agreementDetail.suppliersApplyId,
                        reject:0,
                        content:"同意"
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.$message({
                                message: '复审成功',
                                type: 'success'
                            });
                            window.opener = null;
                            window.open('', '_self');
                            window.close();
                        } else {
                            that.$message.error('复审失败，请联系管理员');
                        }
                    }
                })
            },

            beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
                console.log(isJPG)
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
                    return isJPG;
                }
                if (!isLt1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return isLt1M;
                }
            },

           detail(id,showView){
               this.showView = showView;
               var that = this;
               $.get({
                   url: '/suppliers/supplierSettled/agreement/detail',
                   data: {
                       agreementId: id
                   },
                   success: function(result) {
                       if (!result.code && result.code==0) {
                           that.agreementDetail=result.data;
                           if(that.agreementDetail.applyAgreementBrandList){
                               var brandData = [];
                               for(var i=0;i<that.agreementDetail.applyAgreementBrandList.length;i++){
                                   var brand = that.agreementDetail.applyAgreementBrandList[i];
                                   if(brand.hasCheck){
                                       if(!brand.rate){
                                           brand.rate = "";
                                       }
                                       brandData.push(brand);
                                   }
                               }
                               that.agreementDetail.applyAgreementBrandList = brandData;
                           }
                           that.contractFileArr = that.fileTransToArray(that.agreementDetail.contractFileArr);
                           that.showDetail = 1;
                           that.$parent.showButton = 0;
                           that.$parent.argeementListShowButton = 0;
                       } else {
                           that.$message({
                               showClose: true,
                               message: result.msg,
                               type: 'error'
                           });
                       }
                   }
               })
           },
            /**
             * 打开品牌详情页面
             * @param id
             */
            openAddContract(agreementId){
                window.open("/suppliers/index2/#/agreement_list_edit?supplierApplyId=" + this.supplierApplyId + "&agreementId=" + agreementId);
            },
            addContract() {
                var that = this;
                var Data = {
                    "push":1,
                    "applyId":that.supplierApplyId,
                    "agreementName":"1232",
                    "cooperationType":1,
                    "deliveryTime":72,
                    "contractStartTime":1494933017000,
                    "contractEndTime":1494933030000,
                    "settlementBodyId":1,
                    "settlementType":1,
                    "settlementPaymentDays":30,
                    "settlementPaymentRate":"30,70",
                    "contractFile":"http://pic.davdian.com/goods/2017/05/12/525_543_d7668b67667d540103e01bef49e275ab.png",
                    "contractTemplateId":1,
                    "shouldDeposit":10000,
                    "agreementBrands":[
                        {
                            "brandId":1,
                            "categoryId":2116,
                            "provideInvoice":12,
                            "invoiceType":1,
                            "rate":1,
                            "rateArr":[3]
                        }
                    ],
                    "templateContentIds":[
                        "111","222"
                    ]
                }

                $.post({
                    url: '/suppliers/supplierSettled/agreement/save',
                    data: JSON.stringify(Data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    success: function (result) {
                        if (!result.code) {
                            // 后台成功 改变路由
                            that.showDetail = 0;
                            that.$parent.showButton = 1;
                            that.$parent.argeementListShowButton = 1;
                            that.initAgreementList(that.supplierApplyId);
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            removeAgreement(agreementId){
                var that = this;
                this.$confirm('此操作将删除该合同, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    $.ajax({
                        url: '/suppliers/supplierSettled/agreement/remove?agreementId=' + agreementId,
                        contentType: 'application/json;charset=utf-8',
                        type: 'GET',
                        success: function (result) {
                            if (!result.code) {
                                that.$message({
                                    message: '删除合同成功',
                                    type: 'success'
                                });
                                that.initAgreementList(that.supplierApplyId);
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            pushContract() {
                var that = this;
                var Data = {
                    applyId:that.supplierApplyId
                };
                $.ajax({
                    url: '/suppliers/supplierSettled/audit/pushAgreement?applyId=' + that.supplierApplyId,
                    //data: JSON.stringify(Data),
                    //dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'GET',
                    success: function (result) {
                        if (!result.code) {
                            // 后台成功 改变路由
                            // that.showDetail = 1;
                            that.$message({
                                message: '推送合同成功',
                                type: 'success'
                            });
                            // that.initAgreementList(supplierApplyId);
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            initUserApplyAuth(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findUserApplyAuth',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function(result) {
                        if (!result.code && result.code==0) {
                            if (result.data.status == 8) {
                                if (result.data.secondAuditAuth == 1) {
                                    that.secondAuditAuth = 1;
                                }
                            } else {
                                that.secondAuditAuth = 0;
                            }
                            if (result.data.status == 5) {
                                that.auditContractAuth = 1;
                            } else {
                                that.auditContractAuth = 0;
                            }
                            if (result.data.status == 4) {
                                that.editContractAuth = 1;
                            } else {
                                that.editContractAuth = 0;
                            }
                            if (result.data.status == 10) {
                                that.allConfirmationAuth = 1;
                            } else {
                                that.allConfirmationAuth = 0;
                            }
                        } else {

                        }
                    }
                })
            },

            reback(){
                this.$parent.showButton = 1;
                this.$parent.argeementListShowButton = 1;
                this.showDetail = 0;
            },
            // 预览图片
            previewPic (e) {
                console.log(e)
                this.dialogVisible2 = true;
                // 获取当前图片地址
                this.dialogImageUrl2 = e.currentTarget.src;
            }

        },

        mounted () {
            var supplierApplyId = this.$route.query.supplierApplyId;
            this.initAgreementList(supplierApplyId);
            this.initUserApplyAuth(supplierApplyId);
            this.supplierApplyId = supplierApplyId;
            this.agreementId = this.$route.query.agreementId;
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
        margin-left: 3%;
        display: inline-block;
        width: 85%;
        height: 1px;
        border-bottom: 1px dashed #999;
        vertical-align: middle;
    }
    .second_line {
        margin-left: 3%;
        display: inline-block;
        width: 81.8%;
        height: 1px;
        border-bottom: 1px dashed #666;
        vertical-align: middle;
    }
    .word_num {
        display: inline-block;
        vertical-align: bottom;
        margin-bottom: 22px;
        margin-left: 5px;
        color: #666;
    }
    .pic_tip {
        font-size: 12px;
        color: #ff4949;
        line-height: 1px;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
    }
    .pic_skan {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .pic_min_skan {
        width: 60px;
        height: 60px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .form_color {
        color: rgb(106, 72, 77);
    }
    .el-form-item {
        margin-bottom: 0;
    }
    ::-webkit-scrollbar {
        width: 6px;
        height:6px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 3px;
        border-right: 2px solid #f5f5f5;
    }
    .agree_wrap {
        display: inline-block;

    }

    .in_block {

        margin-left: 20px;
    }

    .agree {
        display: inline-block;
        min-width: 100px;

    }
    .mtb20 {
        margin-top: 20px;
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// agreementList.vue?5c53da32